export enum Widget {
  loan = 'LOAN',
  application = 'APPLICATION',
}
